module.exports = __webpack_public_path__ + "img/Kizingo-curved-toddler-spoons-make-feeding-easy.dfb48a38.png";